import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IndianStudentsComponent } from './indian-students.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


const routes: Routes = [
  {
    path: '',
    component: IndianStudentsComponent,
    data: {
      title: "Tech Venture Bootcamp",
      breadcrumb: "Tech Venture Bootcamp"
    }
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [],
  exports: [RouterModule]
})
export class IndianStudentsRoutingModule { }